import { isGoogleMapsReady } from './mapCoordinates';

/** Pin colors by GovOps workflow state (GOVOPS-1107). */
export const STATUS_MARKER_COLORS = {
  intake: '#64748b',
  under_review: '#2563eb',
  notice_sent: '#d97706',
  violation_open: '#dc2626',
  payment_pending: '#7c3aed',
  resolved: '#059669',
  closed: '#334155',
  appealed: '#db2777',
};

/** Circle symbol for Marker — works without AdvancedMarkerElement migration. */
export function getPermitMarkerIcon(status, { selected = false } = {}) {
  if (!isGoogleMapsReady()) return undefined;
  const fill = STATUS_MARKER_COLORS[status] || STATUS_MARKER_COLORS.intake;
  return {
    path: window.google.maps.SymbolPath.CIRCLE,
    fillColor: fill,
    fillOpacity: 0.92,
    strokeColor: selected ? '#0f172a' : '#ffffff',
    strokeWeight: selected ? 3 : 1.5,
    scale: selected ? 11 : 8,
  };
}
